// File: src/theme/foundations.ts
// Define foundational theme settings

const foundations = {
  fonts: {
    heading: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800',
      },
      // Add scroll-margin-top to section anchors to prevent header overlap
      '[id]': {
        scrollMarginTop: { base: '5rem', md: '6rem' }
      },
      // Remove extra spacing around section headings
      'section h2, section h3': {
        paddingTop: 0,
        marginTop: 0
      },
    },
  },
  breakpoints: {
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em',
  },
};

export default foundations;